


  
  

  var faRegularAddressCardCircleCheck = {
    prefix: 'fak',
    iconName: 'regular-address-card-circle-check',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 115.2c-14.9-7.6-31-13.2-48-16.3L528 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l268 0c6.9 17.5 16.5 33.7 28.3 48L64 480c-35.3 0-64-28.7-64-64L0 96zM96 368c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm56.6-208c11.4-19.8 32.6-32 55.4-32s44 12.2 55.4 32s11.4 44.2 0 64s-32.6 32-55.4 32s-44-12.2-55.4-32s-11.4-44.2 0-64zM352 168c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zm0 96c0-13 10.3-23.6 23.2-24c-8.5 8.1-16.3 17-23.1 26.6c-.1-.9-.1-1.7-.1-2.6zm0 104c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faRegularAnglesDownUp = {
    prefix: 'fak',
    iconName: 'regular-angles-down-up',
    icon: [
      384,
      512,
      [],
      'e013',
      
      'M207.5 176.3c-9.1 7.2-21.9 7.2-31 0L11.4 44.2C.6 35.6-1 20 7.5 9.4S31.7-3 42.3 5.4L192 125.2 341.7 5.4c10.7-8.6 26.3-6.8 34.8 3.9s6.8 26.3-3.9 34.8L207.4 176.3l.1 0zM176.5 335.7c9.1-7.2 21.9-7.2 31 0L372.6 467.8c10.7 8.6 12.4 24.2 3.8 34.8s-24.2 12.4-34.8 3.9L192 386.8 42.2 506.6c-10.7 8.6-26.3 6.8-34.8-3.9s-6.8-26.3 3.9-34.8L176.6 335.7l-.1 0z'
      
    ]
  };

  

  
  

  var faRegularChecklistSection = {
    prefix: 'fak',
    iconName: 'regular-checklist-section',
    icon: [
      512,
      512,
      [],
      'e012',
      
      'M51.2 204.8c0-28.3 22.9-51.2 51.2-51.2l307.2 0c28.3 0 51.2 22.9 51.2 51.2l0 102.4c0 28.3-22.9 51.2-51.2 51.2l-307.2 0c-28.3 0-51.2-22.9-51.2-51.2l0-102.4zM102.4 192c-7.1 0-12.8 5.7-12.8 12.8l0 102.4c0 7.1 5.7 12.8 12.8 12.8l307.2 0c7.1 0 12.8-5.7 12.8-12.8l0-102.4c0-7.1-5.7-12.8-12.8-12.8l-307.2 0zM51.2 416c0-10.6 8.6-19.2 19.2-19.2l371.2 0c10.6 0 19.2 8.6 19.2 19.2s-8.6 19.2-19.2 19.2l-371.2 0c-10.6 0-19.2-8.6-19.2-19.2zm0-320c0-10.6 8.6-19.2 19.2-19.2l371.2 0c10.6 0 19.2 8.6 19.2 19.2s-8.6 19.2-19.2 19.2l-371.2 0c-10.6 0-19.2-8.6-19.2-19.2z'
      
    ]
  };

  

  
  

  var faRegularCircleUserCircleCheck = {
    prefix: 'fak',
    iconName: 'regular-circle-user-circle-check',
    icon: [
      640,
      512,
      [],
      'e00c',
      
      'M34.3 128C80 48.8 164.5 0 256 0s176 48.8 221.7 128c11.8 20.4 20.5 42 26.2 64.2c-2.6-.1-5.3-.2-7.9-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256c0 55.7 21.9 106.2 57.5 143.6c19.1-46.7 65-79.6 118.5-79.6l64 0c12.9 0 25.4 1.9 37.2 5.5c-3.4 13.6-5.2 27.9-5.2 42.5c0 2.2 0 4.5 .1 6.7c-9.8-4.3-20.7-6.7-32.1-6.7l-64 0c-38.8 0-71.2 27.6-78.5 64.3C177.6 452.4 215.4 464 256 464c29.4 0 57.3-6.1 82.7-17.1c7.4 14.6 16.7 28.1 27.7 40.1c-33.9 16.2-71.5 25-110.4 25c-91.5 0-176-48.8-221.7-128s-45.7-176.8 0-256zM168 200c0-31.4 16.8-60.5 44-76.2s60.8-15.7 88 0s44 44.8 44 76.2s-16.8 60.5-44 76.2s-60.8 15.7-88 0s-44-44.8-44-76.2zm53.4-20c-7.1 12.4-7.1 27.6 0 40s20.4 20 34.6 20s27.5-7.6 34.6-20s7.1-27.6 0-40s-20.4-20-34.6-20s-27.5 7.6-34.6 20zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faRegularDsChevronDown = {
    prefix: 'fak',
    iconName: 'regular-ds-chevron-down',
    icon: [
      488,
      512,
      [],
      'e014',
      
      'M231.7 320.6c6.8 6.8 17.8 6.8 24.6 0L360.8 216.1c6.8-6.8 6.8-17.8 0-24.6s-17.8-6.8-24.6 0L244 283.6l-92.2-92.1c-6.8-6.8-17.8-6.8-24.6 0s-6.8 17.8 0 24.6L231.7 320.6l.1-.1z'
      
    ]
  };

  

  
  

  var faRegularFileLinesPen = {
    prefix: 'fak',
    iconName: 'regular-file-lines-pen',
    icon: [
      576,
      512,
      [],
      'e00e',
      
      'M0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.2 6.7 45.2 18.7l90.6 90.5c12 12 18.7 28.3 18.7 45.3l0 145.2-48 48L336 160l-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l198.5 0-5.1 20.2c-2.3 9.3-1.8 19 1.4 27.8L64 512c-35.3 0-64-28.7-64-64L0 64zM96 280c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM289.5 492.1l15-60.1c1.4-5.7 4.3-10.8 8.4-14.9L442.2 287.9l-.1 0 71 71L383.9 488.1c-4.1 4.1-9.3 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2zM464.8 265.3l29.4-29.4c15.7-15.6 41-15.6 56.6 0l14.3 14.3c15.6 15.7 15.6 41 0 56.6l-29.4 29.4-70.9-70.9z'
      
    ]
  };

  

  
  

  var faRegularFileMagnifyingGlass = {
    prefix: 'fak',
    iconName: 'regular-file-magnifying-glass',
    icon: [
      576,
      512,
      [],
      'e00f',
      
      'M0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 5.5c-16.7 0-32.8 2.6-48 7.3l0-7.3-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l250.1 0c18.7 9.1 39.5 14.6 61.4 15.8C364.5 499 343.7 512 320 512L64 512c-35.3 0-64-28.7-64-64L0 64zM256 320c0-70.7 57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L569 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L456 425.8l-.1 .1C435.4 439.8 410.7 448 384 448c-70.7 0-128-57.3-128-128zm48 0c0 28.6 15.2 55 40 69.3s55.2 14.3 80 0s40-40.7 40-69.3s-15.2-55-40-69.3s-55.2-14.3-80 0s-40 40.7-40 69.3z'
      
    ]
  };

  

  
  

  var faRegularFolderCircleArrowRight = {
    prefix: 'fak',
    iconName: 'regular-folder-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e002',
      
      'M0 96C0 60.7 28.7 32 64 32c44 0 88.1 0 132.1 0c19.1 0 37.4 7.6 50.9 21.1c14.3 14.3 28.6 28.6 42.9 42.9L448 96c35.3 0 64 28.7 64 64c0 10.9 0 21.8 0 32.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9c0-11.6 0-23.3 0-34.9c0-8.8-7.2-16-16-16c-53.8 0-107.6 0-161.4 0c-10.6 0-20.8-4.2-28.3-11.7c-15.1-15.1-30.1-30.2-45.2-45.3c-4.5-4.5-10.6-7-17-7c-44 0-88.1 0-132.1 0c-8.8 0-16 7.2-16 16c0 106.7 0 213.3 0 320c0 8.8 7.2 16 16 16c89.4 0 178.7 0 268 0c6.9 17.5 16.5 33.7 28.3 48c-98.8 0-197.5 0-296.3 0c-35.3 0-64-28.7-64-64C0 309.3 0 202.7 0 96zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16c29.8 0 59.6 0 89.4 0c-9.6 9.6-19.1 19.1-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c18.7-18.7 37.3-37.3 56-56c6.2-6.2 6.2-16.4 0-22.6c-18.7-18.7-37.3-37.3-56-56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6c9.6 9.6 19.1 19.1 28.7 28.7c-29.8 0-59.6 0-89.4 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faSolidAddressCardCircleCheck = {
    prefix: 'fak',
    iconName: 'solid-address-card-circle-check',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 115.2c-24-12.3-51.2-19.2-80-19.2c-37.7 0-72.6 11.8-101.2 32L368 224c-8.8 0-16 7.2-16 16c0 6.5 3.9 12.1 9.4 14.6C335.6 285.2 320 324.8 320 368c0 42.5 15.1 81.6 40.3 112L64 480c-35.3 0-64-28.7-64-64L0 96zM64 368c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80zm48-176c0 22.9 12.2 44 32 55.4s44.2 11.4 64 0s32-32.6 32-55.4s-12.2-44-32-55.4s-44.2-11.4-64 0s-32 32.6-32 55.4zm240-16c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zm0 192c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faSolidCircleUserCircleCheck = {
    prefix: 'fak',
    iconName: 'solid-circle-user-circle-check',
    icon: [
      640,
      512,
      [],
      'e009',
      
      'M0 256C0 164.5 48.8 80 128 34.3s176.8-45.7 256 0c60.3 34.8 103 92.1 119.9 157.9c-2.6-.1-5.3-.2-7.9-.2c-82.5 0-151.8 56.8-170.8 133.5c-11.8-3.6-24.3-5.5-37.2-5.5l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8c27.1 0 52.8-5.6 76.1-15.7c8 20.3 19.7 38.9 34.2 54.7c-75.7 36.2-164.9 33.1-238.4-9.3C48.8 432 0 347.5 0 256zm193.6-92c-12.9 22.3-12.9 49.7 0 72s36.6 36 62.4 36s49.5-13.7 62.4-36s12.9-49.7 0-72s-36.6-36-62.4-36s-49.5 13.7-62.4 36zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  



export {

  faRegularAddressCardCircleCheck,
  

  faRegularAnglesDownUp,
  

  faRegularChecklistSection,
  

  faRegularCircleUserCircleCheck,
  

  faRegularDsChevronDown,
  

  faRegularFileLinesPen,
  

  faRegularFileMagnifyingGlass,
  

  faRegularFolderCircleArrowRight,
  

  faSolidAddressCardCircleCheck,
  

  faSolidCircleUserCircleCheck,
  

};
